import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useGrid, useModal, useStore, useToast, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_GFS_CD_LIST, SF_GFS_CD_LIST_SRCH } from "./services/OsciGfsMgmtService"; // 서비스
import dayjs from "dayjs";

/*
 * GFS Code List
 * !== GFS 코드 목록 ==!
 */
export const OSCI0406005Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0019", "auth_osci0021"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // GFS Code Search Form !== GFS 코드 검색 폼 ==!
        gfsCdSrch: useForm({
            defaultSchema: SF_GFS_CD_LIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };
    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // GFS Code List Grid !== GFS 코드 목록 그리드 ==!
        gfsCdList: useGrid({
            defaultSchema: SG_GFS_CD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get GFS Code List !== Gfs Code 목록 조회 ==!
        getGfsCdList: useFetch({
            api: (page = grid.gfsCdList.page) => {
                return APIS.getGfsCdList(form.gfsCdSrch.getValues(), page, grid.gfsCdList.size);
            },
            enabled: comnUtils.isEmpty(form.gfsCdSrch.errors) && form.gfsCdSrch.isSubmitted,
            key: [grid.gfsCdList.page, grid.gfsCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.gfsCdSrch.getValues(),
                    page: grid.gfsCdList.page,
                    size: grid.gfsCdList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Delete GFS Code !== GFS 코드 삭제 ==!
        deleteGfsCd: useFetch({
            api: (gfsCds) => APIS.deleteGfsCd(gfsCds),
            onSuccess: () => {
                modal.openModal({ content: "msg.00003" });
                handler.getGfsCdList();
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get GFS Code List !== GFS 코드 목록 조회 ==!
        getGfsCdList: (page: number = 0) => {
            form.gfsCdSrch.handleSubmit(
                (data) => {
                    grid.gfsCdList.setPage(page);
                    fetch.getGfsCdList.fetch(page);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        // Delete GFS Code !== GFS 코드 삭제 ==!
        deleteGfsCd: () => {
            const seltList: any[] = grid.gfsCdList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }

            modal.openModal({
                content: "msg.00103",
                onConfirm: () => {
                    const gfsCds: string[] = [];
                    seltList.forEach((item) => {
                        gfsCds.push(`${item.gfsCd}`);
                    });

                    fetch.deleteGfsCd.fetch(gfsCds.join(","));
                },
            });
        },
        // Click Grid of GFS Code List !== GFS 코드 목록 그리드 클릭 ==!
        click_gridCell_gfsCdList: {
            gfsCd: (props: any) => {
                const { binding, rowValues, value } = props;
                console.log(props);
            },
        },
        click_gridRow_gfsCdList: (data: any) => {
            const { binding, rowValues, value } = props;
            console.log(props);
        },
    };

    const render = {
        grid_GfsCdList: {
            head: {},
            cell: {
                gfsCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span style={{ color: "blue" }}>
                            <Link to={`${URLS.osci0406006q}/${rowValues.gfsCd}`}>{`${rowValues.gfsCd}`}</Link>
                        </span>
                    );
                },
            },
            edit: {},
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getGfsCdList(pgeStore?.page);
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.gfsCdSrch.schema.gfsCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>

                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.gfsCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getGfsCdList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.gfsCdList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,

                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                            <Button
                                role="excelUpload"
                                onClick={() => {
                                    modal.openModal({
                                        url: URLS.osci0406008s,
                                        params: {},
                                        size: "lg",
                                        callback: (data: any) => {
                                            modal.closeModal();
                                            fetch.getGfsCdList.fetch(pgeStore?.page);
                                        },
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            {/* <Button
                                role="delete"
                                onClick={() => {
                                    handler.deleteGfsCd();
                                }}
                            ></Button> */}
                        </Layout.Right>
                    </Layout>
                    <Grid
                        {...grid.gfsCdList.grid}
                        data={fetch.getGfsCdList.data?.gfsCdList}
                        render={render.grid_GfsCdList}
                        //onCellClick={handler.click_gridCell_gfsCdList}
                        //onRowClick={handler.click_gridRow_gfsCdList}
                    />
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    {/* <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.osci0406007s);
                        }}
                    ></Button> */}
                </Layout.Left>
            </Layout>
        </Page>
    );
};
